import axiosInstance from './axios';
import { PaginationParams, PaginationResponse } from './config';

// Alert Admin 타입 정의
export interface AlertAdminCreateRequest {
  name: string;
  contact: string;
  department?: string;
  memo?: string;
  regions: string[];
}

export interface AlertAdminUpdateRequest extends AlertAdminCreateRequest {
  isActive?: boolean;
}

export interface AlertAdminResponse {
  id: number;
  name: string;
  contact: string;
  department?: string;
  memo?: string;
  regions: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface AlertAdminSearchParams extends PaginationParams {
  keyword?: string;
  searchType?: 'name' | 'contact' | 'department';
}

/**
 * 경보 관리자 목록 조회
 */
export const getAlertAdminsApi = async (params: PaginationParams = {}): Promise<PaginationResponse<AlertAdminResponse>> => {
  const response = await axiosInstance.get('/api/alert-admin', { params });
  return response.data;
};

/**
 * 경보 관리자 검색
 */
export const searchAlertAdminsApi = async (params: AlertAdminSearchParams): Promise<PaginationResponse<AlertAdminResponse>> => {
  const response = await axiosInstance.get('/api/alert-admin/search', { params });
  return response.data;
};

/**
 * 경보 관리자 상세 조회
 */
export const getAlertAdminApi = async (id: number): Promise<AlertAdminResponse> => {
  const response = await axiosInstance.get(`/api/alert-admin/${id}`);
  return response.data;
};

/**
 * 경보 관리자 등록
 */
export const createAlertAdminApi = async (data: AlertAdminCreateRequest): Promise<AlertAdminResponse> => {
  const response = await axiosInstance.post('/api/alert-admin', data);
  return response.data;
};

/**
 * 경보 관리자 수정
 */
export const updateAlertAdminApi = async (id: number, data: AlertAdminUpdateRequest): Promise<AlertAdminResponse> => {
  const response = await axiosInstance.put(`/api/alert-admin/${id}`, data);
  return response.data;
};

/**
 * 경보 관리자 삭제
 */
export const deleteAlertAdminApi = async (id: number): Promise<void> => {
  const response = await axiosInstance.delete(`/api/alert-admin/${id}`);
  return response.data;
};

/**
 * 지역별 관리자 조회
 */
export const getAlertAdminsByRegionApi = async (regionName: string): Promise<AlertAdminResponse[]> => {
  const response = await axiosInstance.get(`/api/alert-admin/region/${encodeURIComponent(regionName)}`);
  return response.data;
};